import React from 'react';
import {Flex, FlexProps} from '@chakra-ui/react';
import {COLORS} from '../../../config/UIConstants';
import './ChartContainer.css';

interface ChartContainerProps extends FlexProps {
    children: React.ReactNode;
}

/**
 * Container component for chart sections with consistent styling
 */
const ChartContainer: React.FC<ChartContainerProps> = ({
                                                           children,
                                                           ...flexProps
                                                       }) => {
    return (
        <Flex
            className="chart-container"
            bg={COLORS.background}
            borderColor={COLORS.chakraPanel}
            direction="column"
            {...flexProps}
        >
            {children}
        </Flex>
    );
};

export default ChartContainer;